import { useEffect, useState } from 'react';

type InstructorToastVariant = 'success' | 'error';

interface InstructorToastState {
  message: string;
  variant: InstructorToastVariant;
}

const useInstructorToast = () => {
  const [toast, setToast] = useState<InstructorToastState | null>(null);

  useEffect(() => {
    if (!toast) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => setToast(null), 2600);

    return () => window.clearTimeout(timeoutId);
  }, [toast]);

  const showToast = (message: string, variant: InstructorToastVariant = 'success') => {
    setToast({ message, variant });
  };

  return { showToast, toast };
};

export { useInstructorToast };
export type { InstructorToastState, InstructorToastVariant };
